import { Box, styled } from "@mui/material";
import { theme } from "../../theme";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";

export const LeadRetrievalSettings = {
  title: {
    display: "flex",
    alignItems: "center",
    marginBottom: "3px",
  },
  enableReportStyle: {
    "&.switchComponent": {
      "& .MuiTypography-root": {
        fontWeight: "600",
        // color: "#444444",
      },

      "& .MuiFormControlLabel-root": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      },
    },
  },
  baseWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 150px)",
  },
  fieldsWrapper: {
    py: "15px",
    pl: "15px",
    pr: 0,
    width: "95%",
    overflow: "auto",
    m: "auto",
    flexGrow: 1,
    border: `1px solid ${theme.palette.grey[600]}`,
    "& .fieldsLoading":{height:"100%",marginTop:"0"},
  },
  mainContainer:{
    height: "100%",
    overflow: "auto",
    paddingRight: "15px",
  },
  titleDiv:{
    display: "flex",
    alignItems: "flex-start",
    textAlign: "left",
    gap:2,
    // "& > p": { width: "50%" },
  },
  backButton: {
    fontSize: "12px",
    textDecoration: "underline",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "none",
    },
  },
  deleteSection: {
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
    "& .MuiBox-root": { width: "100%", transition: "all 1s ease-out" },
    "& .MuiFormControl-root": { m: 0 },
    "& .deleteBtn": {
      transition: "all 0.2s ease-out",
      opacity: 0,
      width: 0,
      overflow: "hidden",
      marginTop:"5px",
      marginLeft:"-16px",

    },
    "&:hover": {
      "& .deleteBtn": {
        opacity: 1,
        width: "initial",
        overflow:'visible',
        marginLeft:"-4px",
      },
    },
  },
  mappingBox: {
    marginBottom: "15px",
    backgroundColor: '#F6F8F8',
    padding: "15px",
    borderRadius: "5px",
    "& .MuiBox-root": { width: "100%" },
    "& .MuiFormControl-root": { m: 0 },
    "&.mandatory,&.erroredBlock":{
      backgroundColor: '#FDF0EE',
    },
    "&.mandatory,&.defaultField":{
      backgroundColor: '#F2F8EA',
    }
    
  },
  textfield: {
    "&.MuiFormControl-root": { "&:hover": { cursor: "not-allowed" } },
    "& .MuiInputBase-root": { background: "#F0F0F0", color: "#C0C0C0",cursor: "not-allowed", "& input":{cursor: "not-allowed",} },
    "& .MuiFormHelperText-root": { my: "8px", mx: 0 },
  },
  flexXYCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  settingTitle: { fontWeight: "600", 
    // color: "#444444" 

  },
  selectDisabled:{
    textAlign: "left",
    "&.Mui-disabled": {
      cursor: "not-allowed",
      "& .Mui-disabled": {
        cursor: "not-allowed",
      },
    },
  },
  checkBoxStyle:{
      display: "flex",
      marginRight: "10px",
      marginLeft: "0px",
      "& .MuiCheckbox-root": {
        padding: "0 9px",
      },
      "&.Mui-disabled":{
        cursor:"not-allowed"
      },
  }
} as const;

export const H2 = styled(FdTypography)({
  marginBottom: "10px",
});

H2.defaultProps = {
  variant: "h2",
};
export const SettingBox = styled(Box)({
  "& > div": {
    padding: "10px 10px",
  },
  "& > div:nth-of-type(odd)": {
    backgroundColor: "#F3F3F3",
  },
  "& > div:nth-of-type(even)": {
    backgroundColor: "#fff",
  },
});
export const SettingTitle = styled(FdTypography)({
  variant: "body1",
  component: "h6",
  marginBottom: "10px",
  fontWeight:"500",
  flex:1,
});
